export default Object.freeze([
  "Leistungen Dritter",
  "Personalaufwand",
  "Kreditkarten",
  "RAUMAUFWAND",
  "ENERGIE- UND ENTSORGUNGSAUFWAND",
  "SACHVERSICH., ABGABEN, GEBÜHREN, BEWILLIGUNGEN",
  "FAHRZEUG- UND TRANSPORTAUFWAND",
  "WERBEAUFWAND",
  "Reisespesen/Kundenbetreuung",
  "Reparaturen / Wartungen",
  "VERWALTUNGS-AUFWAND",
  "INFORMATIKAUFWAND",
  "Beratungskosten",
  "Lizenzen",
  "ÜBRIGER BETRIEBSAUFWAND",
  "Forderungsverluste",
  "Fitnessgeräte und Solarien",
  "Sauna / Dampfbad",
  "Handelswaren",
  "Leasing Maschinen",
  "Steuern",
  "Mobilien und Einrichtungen",
  "Nicht Gewinnwirksame Aufwände",
  "Büromobiliar/Büro-/EDV-Geräte",
  "Fahrzeuge",
  "Unbekannt",
])
